export function splitRequirements(chunk: string): string[] {
  let buffer = chunk;
  const lines: string[] = [];
  let newlineIndex = buffer.indexOf("\n");

  while (newlineIndex !== -1) {
    let line = buffer.slice(0, newlineIndex);
    if (line.endsWith("\r")) {
      line = line.slice(0, -1);
    }
    lines.push(line);
    buffer = buffer.slice(newlineIndex + 1);
    newlineIndex = buffer.indexOf("\n");
  }

  // Handle any remaining content in the buffer
  if (buffer.length > 0) {
    lines.push(buffer);
  } else if (chunk.endsWith("\n")) {
    // If the chunk ends with a newline, add an empty line
    lines.push("");
  }

  return lines;
}
